var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { attrs: { role: "navigation", "aria-label": "Pagination Navigation" } },
    [
      _c("ul", { staticClass: "v-pagination theme--dark" }, [
        _c(
          "li",
          [
            _vm.value > 1
              ? _c(
                  "router-link",
                  {
                    staticClass: "v-pagination__item",
                    attrs: { to: _vm.pageLink(_vm.value - 1), event: "" },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.changePage(_vm.value - 1)
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v(_vm._s(_vm.mdiChevronLeft))])],
                  1
                )
              : _c(
                  "button",
                  {
                    staticClass:
                      "v-pagination__navigation v-pagination__navigation--disabled",
                    attrs: { "aria-label": "Previous page" }
                  },
                  [_c("v-icon", [_vm._v(_vm._s(_vm.mdiChevronLeft))])],
                  1
                )
          ],
          1
        ),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                staticClass: "v-pagination__item",
                class: { active: _vm.value === 1 },
                attrs: { to: _vm.pageLink(1), event: "" },
                nativeOn: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changePage(1)
                  }
                }
              },
              [_vm._v("1\n            ")]
            )
          ],
          1
        ),
        _vm.length > _vm.showingItemsCount &&
        _vm.value >= _vm.showingItemsCount - 1
          ? _c("li", [
              _c("span", { staticClass: "v-pagination__more" }, [_vm._v("...")])
            ])
          : _vm._e(),
        _vm.length <= _vm.showingItemsCount
          ? _c(
              "li",
              _vm._l(Math.max(_vm.length - 2, 0), function(index) {
                return _c(
                  "router-link",
                  {
                    key: index,
                    staticClass: "v-pagination__item",
                    class: { active: index + 1 === _vm.value },
                    attrs: { to: _vm.pageLink(index + 1), event: "" },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.changePage(index + 1)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(index + 1) +
                        "\n            "
                    )
                  ]
                )
              }),
              1
            )
          : _vm.length > _vm.showingItemsCount &&
            _vm.value < _vm.showingItemsCount - 1
          ? _c(
              "li",
              _vm._l(Math.max(_vm.showingItemsCount - 2, 0), function(index) {
                return _c(
                  "router-link",
                  {
                    key: index,
                    staticClass: "v-pagination__item",
                    class: { active: index + 1 === _vm.value },
                    attrs: { to: _vm.pageLink(index + 1), event: "" },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.changePage(index + 1)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(index + 1) +
                        "\n            "
                    )
                  ]
                )
              }),
              1
            )
          : _vm.length > _vm.showingItemsCount &&
            _vm.value > _vm.length - _vm.showingItemsCount + 2
          ? _c(
              "li",
              _vm._l(Math.max(_vm.showingItemsCount - 2, 0), function(index) {
                return _c(
                  "router-link",
                  {
                    key: index,
                    staticClass: "v-pagination__item",
                    class: {
                      active:
                        index + _vm.length - _vm.showingItemsCount + 1 ===
                        _vm.value
                    },
                    attrs: { to: _vm.pageLink(index + 1), event: "" },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.changePage(
                          index + _vm.length - _vm.showingItemsCount + 1
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(index + _vm.length - _vm.showingItemsCount + 1) +
                        "\n            "
                    )
                  ]
                )
              }),
              1
            )
          : _c(
              "li",
              _vm._l(Math.max(_vm.showingItemsCount - 2, 0), function(index) {
                return _c(
                  "router-link",
                  {
                    key: index,
                    staticClass: "v-pagination__item",
                    class: {
                      active:
                        index +
                          Math.min(_vm.value - _vm.showingItemsCount / 2) ===
                        _vm.value
                    },
                    attrs: { to: _vm.pageLink(index + 1), event: "" },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.changePage(
                          index +
                            Math.min(_vm.value - _vm.showingItemsCount / 2)
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          index +
                            Math.min(_vm.value - _vm.showingItemsCount / 2)
                        ) +
                        "\n            "
                    )
                  ]
                )
              }),
              1
            ),
        _vm.length > _vm.showingItemsCount &&
        _vm.value <= _vm.length - _vm.showingItemsCount + 2
          ? _c("li", [
              _c("span", { staticClass: "v-pagination__more" }, [_vm._v("...")])
            ])
          : _vm._e(),
        _vm.length > 1
          ? _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "v-pagination__item",
                    class: { active: _vm.value === _vm.length },
                    attrs: { to: _vm.pageLink(_vm.length), event: "" },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.changePage(_vm.length)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.length) + "\n            ")]
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "li",
          [
            _vm.value < _vm.length
              ? _c(
                  "router-link",
                  {
                    staticClass: "v-pagination__item",
                    attrs: { to: _vm.pageLink(_vm.value + 1), event: "" },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.changePage(_vm.value + 1)
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v(_vm._s(_vm.mdiChevronRight))])],
                  1
                )
              : _c(
                  "button",
                  {
                    staticClass:
                      "v-pagination__navigation v-pagination__navigation--disabled",
                    attrs: { "aria-label": "Next page" }
                  },
                  [_c("v-icon", [_vm._v(_vm._s(_vm.mdiChevronRight))])],
                  1
                )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }